import React, { useEffect, useState } from 'react'
import './CardsRow.sass'
import { ChartName, ChartRowObject } from '../../types/data'
import { getRequestHeader } from '../../utility/functions'
import { getChartData } from '../../resources/api-constants'
import axios from 'axios'
import PositionIcon from '../PositionIcon/PositionIcon'

interface Props {
    token?: string
    needsToken?: boolean
    chartTimeSpan: ChartName
    limit?: number
}

const CardsRow: React.FC<Props> = (props) => {
    const [radioData, setRadioData] = useState<ChartRowObject[]>([])

    const fetchChartsData = async () => {
        try {
            const radioCharts: ChartRowObject[] = await axios
                .get(getChartData('audio', props.chartTimeSpan, !!props.token), getRequestHeader(props.token || ''))
                .then((response) => response.data)
            if (radioCharts) setRadioData(props.limit ? radioCharts.slice(0, props.limit) : radioCharts)
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        if (props.needsToken && !props.token) return
        void fetchChartsData()
    }, [props.token, props.needsToken])

    return (
        <div className="radio-cards-row">
            {radioData.map((radio) => (
                <RadioCard
                    key={radio.id_radio}
                    position={radio.position}
                    previous_position={radio.previous_position}
                    logo={radio.logo}
                    name={radio.name}
                />
            ))}
        </div>
    )
}

export default CardsRow

const RadioCard: React.FC<{ position: number; previous_position: number; logo: string; name: string }> = ({
    position,
    previous_position,
    logo,
    name,
}) => {
    return (
        <div className="radio-card">
            <div className="row-container small-space-sx">
                <div>
                    <b>{position}</b>
                </div>
                <div>
                    <PositionIcon currentPosition={position} previousPosition={previous_position} />
                </div>
            </div>
            <div className="row-container">
                <div className="logo-container">
                    <img src={logo} alt={name} />
                </div>
                <span className="bold-text">{name}</span>
            </div>
        </div>
    )
}
